import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
    label: {},
    status: {},
    iconName: {}
  },
  setup(__props: any) {

const props = __props;

const computedClass = computed(() => {
	switch (props.status) {
		case 'success':
			return 'status-badge--success';
		case 'pending':
			return 'status-badge--pending';
		case 'error':
			return 'status-badge--error';
		case 'warning':
			return 'status-badge--warning';
		case 'default':
		default:
			return 'status-badge--default';
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['status-badge', computedClass.value])
  }, [
    (_ctx.iconName)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`mr-1 bx ${_ctx.iconName}`)
        }, null, 2))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.label?.replace('_', ' ').toLowerCase() || 'no available info'), 1)
  ], 2))
}
}

})